import { render } from "./AddPatientDialog.vue?vue&type=template&id=7d606be6&scoped=true"
import script from "./AddPatientDialog.vue?vue&type=script&lang=js"
export * from "./AddPatientDialog.vue?vue&type=script&lang=js"

import "./AddPatientDialog.vue?vue&type=style&index=0&id=7d606be6&lang=css"
import "./AddPatientDialog.vue?vue&type=style&index=1&id=7d606be6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d606be6"]])

export default __exports__